<template>
  <div v-if="currentTraining != null" class="box">
    <div class="row">
      <div class="col-md-6">
        <div class="box-body">
          <div>EN</div>
          <div class="form-group">
            <label for="nameen">{{ $t('trainings.description.name') }}</label>
            <input v-model="currentTraining.name['en']" type="text" class="form-control" id="nameen">
          </div>
          <div class="form-group">
            <label>{{ $t('trainings.description.sport-type') }}</label>
            <select class="form-control" id="countryen" v-model="currentTraining.sportType.id">
              <option
                v-for="sportType in sportTypes"
                v-bind:value="sportType.id"
                :key="sportType.id">
                {{ sportType.name['en'] }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <div class="box box-default collapsed-box">
              <div class="box-header with-border">
                <h3 class="box-title">{{ $t('trainings.description.description') }}</h3>
                <div class="box-tools pull-right">
                  <button type="button" class="btn btn-box-tool" data-widget="collapse"><i
                    class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
              <div class="box-body" style="display: none;">
              <textarea style="height: 500px; width: 100%;"
                        v-model="currentTraining.description['en']"></textarea>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>{{ $t('trainings.description.ages.value') }}</label>
            <div class="input-group">
              <span class="input-group-addon">{{ $t('trainings.description.ages.from') }}</span>
              <input v-model="currentTraining.age.minAge" type="text" class="form-control">
            </div>
            <div class="input-group">
              <span class="input-group-addon">{{ $t('trainings.description.ages.to') }}</span>
              <input v-model="currentTraining.age.maxAge" type="text" class="form-control">
            </div>
          </div>
          <div class="form-group">
            <label for="checkbox">{{ $t('trainings.description.qualification.title') }}</label>
            <div class="checkbox">
              <label>
                <input type="checkbox" id="checkbox" :value="currentTraining.qualificationAmateur"
                       name="qualificationAmateur" v-model="currentTraining.qualificationAmateur">
                {{ $t('trainings.description.qualification.amateur') }}
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input type="checkbox" :value="currentTraining.qualificationProfessional"
                       name="qualificationProfessional" v-model="currentTraining.qualificationProfessional">
                {{ $t('trainings.description.qualification.professional') }}
              </label>
            </div>
          </div>

          <div class="form-group" style="display:none">
            <label for="isPublish">{{ $t('trainings.description.is-publish') }}</label>
            <div class="checkbox">
              <label>
                <input type="checkbox" id="isPublish" :value="currentTraining.isPublish"
                       name="isPublish" v-model="currentTraining.isPublish">
                {{ $t('trainings.description.is-publish') }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="box-body">
          <div>RU</div>
          <div class="form-group">
            <label for="name">{{ $t('trainings.description.name') }}</label>
            <input v-model="currentTraining.name['ru']" type="text" class="form-control" id="name">
          </div>
          <div class="form-group">
            <label>{{ $t('trainings.description.sport-type') }}</label>
            <select class="form-control" id="country" v-model="currentTraining.sportType.id">
              <option
                v-for="sportType in sportTypes"
                :key="sportType.id"
                v-bind:value="sportType.id">
                {{ sportType.name['ru'] }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <div class="box box-default collapsed-box">
              <div class="box-header with-border">
                <h3 class="box-title">{{ $t('trainings.description.description') }}</h3>
                <div class="box-tools pull-right">
                  <button type="button" class="btn btn-box-tool" data-widget="collapse"><i
                    class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
              <div class="box-body" style="display: none;">
              <textarea style="height: 500px; width: 100%;"
                        v-model="currentTraining.description['ru']"></textarea>
              </div>
            </div>
          </div>

          <div class="form-group" style="display:none">
            <label for="isPublish">{{ $t('trainings.description.is-publish') }}</label>
            <div class="checkbox">
              <label>
                <input type="checkbox" :value="currentTraining.isPublish"
                       name="isPublish" v-model="currentTraining.isPublish">
                {{ $t('trainings.description.is-publish') }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button v-on:click="saveTraining" type="button" class="btn btn-primary">{{$t('button.save-changes')}}</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TrainingDescription',
  props: {
    currentTraining: Object,
    sportTypes: Array
  },
  created () {

  },
  updated () {
    // eslint-disable-next-line no-undef
    $('.box').boxWidget();
  },
  methods: {
    saveTraining: function () {
      let self = this;

      let trainingId = self.currentTraining.id;

      console.log(self.currentTraining);

      let q = [];

      if (self.currentTraining.qualificationAmateur) {
        q.push(1);
      }

      if (self.currentTraining.qualificationProfessional) {
        q.push(2);
      }

      let savedTraining =
          {
            'id': trainingId,
            'campId': self.currentTraining.camp.id,
            'name': self.currentTraining.name,
            'sportTypeId': self.currentTraining.sportType.id,
            'minAge': self.currentTraining.age.minAge,
            'maxAge': self.currentTraining.age.maxAge,
            'qualification': q,
            'description': self.currentTraining.description,
            'parameters': '',
            'video': self.currentTraining.video,
            'isPublish': self.currentTraining.isPublish
          };

      axios.put(
        // window.rootRoute + '/api/trainings', {training: savedTraining})
        window.host + '/sport-programs/' + trainingId, savedTraining)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>
